var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogleSearchConsole = function SvgGoogleSearchConsole(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 2230,
    viewBox: "0 0 296 264"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b7b",
    fillRule: "evenodd",
    d: "m83 22 22-22v42H83zm130 0L191 0v42h22z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5a5a5a",
    d: "M105 0h86v21h-86z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e6e7e8",
    d: "M272 264H24a24 24 0 0 1-24-24V83.238L41.238 42h213.524L296 83.238V240a24 24 0 0 1-24 24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d0d1d2",
    d: "M0 127V83.238L41.238 42h213.524L296 83.238V127z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#458cf5",
    d: "M34 264V94a10 10 0 0 1 10-10h208a10 10 0 0 1 10 10v170z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M34 127h228v137H34z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#d2d3d4",
    fillRule: "evenodd",
    d: "M194 264v-41l-20-20-13-36 9-23 51 51 9-38 32 32v75z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#d2d3d4",
    d: "M49 143h76v85H49zm0 104h98v17H49z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    fillRule: "evenodd",
    d: "M213 232.1V264h-42v-31.447a49.507 49.507 0 0 1-1-89.651V190l21 13 22-13v-47.1a49.518 49.518 0 0 1 0 89.2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e7e8",
    fillRule: "evenodd",
    d: "M57.5 95a8.5 8.5 0 1 1-8.5 8.5 8.5 8.5 0 0 1 8.5-8.5m25 0a8.5 8.5 0 1 1-8.5 8.5 8.5 8.5 0 0 1 8.5-8.5"
  })));
};
export default SvgGoogleSearchConsole;